import React from 'react';
import { Check2 } from 'react-bootstrap-icons';

const GETTING_STARTED_STEPS = [
  { id: 'rules', title: 'Setup trading rules' },
  { id: 'broker', title: 'Connect Broker' },
  { id: 'trade', title: 'Start trading' },
  {
    id: 'info',
    info: true,
    title:
      'PrecisionTrader tracks broken rules, new positions, and trading behavior so you can spot mistakes in your trading process.',
  },
];

function stepDone(stepId, progress) {
  if (stepId === 'rules') return !!progress.rulesConfigured;
  if (stepId === 'broker') return !!progress.brokerConnected;
  if (stepId === 'trade') return !!progress.setupComplete;
  return false;
}

/** Welcome / getting-started list for post-onboarding orientation. */
export default function OrientationWelcomeStep({
  rulesConfigured = false,
  brokerConnected = false,
}) {
  const progress = {
    rulesConfigured,
    brokerConnected,
    setupComplete: rulesConfigured && brokerConnected,
  };
  const heading = progress.setupComplete ? "You're all set" : 'Welcome to PrecisionTrader';
  const label = progress.setupComplete ? 'Setup complete' : 'Getting started';

  return (
    <div className="trade-risk-intro">
      <div className="trade-risk-intro__glow" aria-hidden />
      <h2 className="trade-risk-intro__heading">{heading}</h2>
      <div className="trade-risk-intro__body">
        <p className="trade-risk-intro__label">{label}</p>
        <ol className="trade-risk-intro__steps">
          {GETTING_STARTED_STEPS.map((step, i) => {
            const done = !step.info && stepDone(step.id, progress);
            return (
              <li
                key={step.id}
                className={`trade-risk-intro__step${done ? ' trade-risk-intro__step--done' : ''}`}
                style={{ animationDelay: `${80 + i * 70}ms` }}
              >
                <span className="trade-risk-intro__num" aria-hidden>
                  {done ? <Check2 className="trade-risk-intro__check" /> : String(i + 1).padStart(2, '0')}
                </span>
                <span className="trade-risk-intro__text">
                  {done ? <span className="visually-hidden">Completed: </span> : null}
                  {step.title}
                </span>
              </li>
            );
          })}
        </ol>
      </div>
    </div>
  );
}
